import { FC, JSX, useEffect, useState } from "react";
import "./Coupons.scss";
import MasterPage from "../../MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../providers/PaginateProvider";
import { useCoupons } from "../../../providers/Financial/Coupons/CouponsProvider";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";
import SidebarCouponsFilter from "../../../components/Financial/Coupons/SidebarCouponsFilter/SidebarCouponsFilter";
import ModalCouponsInsert from "../../../components/Financial/Coupons/ModalCouponsInsert/ModalCouponsInsert";
import { useStatus } from "../../../providers/Financial/Coupons/Status/StatusProvider";
import moment from "moment";
import FormatMoney from "../../../utils/FormatMoney";

interface CouponsProps { }

const Coupons: FC<CouponsProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [couponEdit, setCouponEdit] = useState<any>({});

  const {
    pages,
    cupons,
    params,
    setParams,
    isLoading,
    error,
    handleList,
    handleDelete,
  } = useCoupons();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();
  const { handleListStatus, statusOptions } = useStatus();

  const handleEdit = (item: any) => {
    setCouponEdit(item);
    setShowModalInsert(true);
  };

  const handleClose = () => {
    setShowModalInsert(false);
    setCouponEdit({});
  };

  const handleDeleteCoupons = (item: any) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir o Cupom ${item?.identifier}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Cupom inativado com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar o Cupom.<br>${error}`,
            "error",
          );
        }
      }
    });
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {cupons?.length > 0 ? (
          <>
            {cupons.map((x: any, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td>{x?.identifier}</td>
                <td className="text-center">
                  {moment(x?.expiration_date).format("DD/MM/YYYY")}
                </td>
                <td className="text-center">{x?.quantity_limit}</td>
                <td className="text-center">
                  {x?.value
                    ? FormatMoney(x.value)
                    : x?.percent
                      ? `${Number(x.percent).toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
                      : "-"}
                </td>
                <td className="text-center">
                  <span
                    className={
                      x?.plan_coupon_status_id === 1 && !x?.deleted_at
                        ? "badge bg-success"
                        : "badge bg-danger"
                    }
                  >
                    {x?.deleted_at
                      ? "INATIVO"
                      : statusOptions
                        .filter((s) => s.value === x?.plan_coupon_status_id)
                        .map((y) => y.label)}
                  </span>
                </td>
                <td>{x?.stripe_coupon_id}</td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    <Dropdown.Item
                      className="border-radius-md py-2"
                      onClick={() => handleEdit(x)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" /> Editar
                    </Dropdown.Item>
                    {!x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleDeleteCoupons(x)}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                        Remover
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={7} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Identificador
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de expiração
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Quantidade limite
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Desconto
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7"
                      scope="col"
                    >
                      Id Stripe
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {cupons?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    setParams({ ...params, page: 1, filter: { only_active: false } });
    handleListStatus({
      page: 1,
      withPaginate: false,
      filter: { only_active: true },
    });
  }, []);

  return (
    <MasterPage title="Coupons" icon="fas fa-file" footerFixed>
      <div className="Coupons" data-testid="Coupons">
        <PageBase
          title="Cupons"
          subtitle="Gerenciamento de cupons cadastrados"
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
          useButtonGroup
        />

        <ModalCouponsInsert
          show={showModalInsert}
          coupon={couponEdit}
          onClose={() => handleClose()}
        />
      </div>

      <SidebarCouponsFilter />
    </MasterPage>
  );
};

export default Coupons;
